import { Reducer } from 'redux';

// Actions

export const selectChart = (chartType: 'tradingView' | 'depth') => ({
  type: 'SELECT_EXCHANGE_CHART' as const,
  chartType,
});

type SelectedChartAction = ReturnType<typeof selectChart>;

// Reducer

type SelectedChartState = {
  chartType: 'tradingView' | 'depth';
};

const defaultState: SelectedChartState = {
  chartType: 'tradingView',
};

// @cached
export const selectedChartReducer: Reducer<
  SelectedChartState,
  SelectedChartAction
> = (state = defaultState, action): SelectedChartState => {
  switch (action.type) {
    case 'SELECT_EXCHANGE_CHART': {
      return {
        chartType: action.chartType,
      };
    }
    default:
      return state;
  }
};
